import { reverseData, removeDuplicates, findIndex, sortDataByTwoColumns, sortData } from './index'

/**
 * This funtcion generate log marking comparing new marking to old marking
 * @param {Object} oldUL old ul marked
 * @param {Object} newUL new ul  marked
 * @param {Number} ilc  index lc marked
 * @param {String} completed type complete markingTeacher || markingStudent
 */
const generateFromToLogMarking = (oldUL, newUL, ilc, completed, minValue = 0) => {
  let from = []
  let to = []
  let gsold = oldUL.lcs[ilc].granularSteps
  let gsnew = newUL.lcs[ilc].granularSteps

  gsold.forEach((oldul, i) => {
    const newul = gsnew[i]

    if (String(oldul[completed]) !== String(newul[completed])) {
      from.push({
        id: oldul.id,
        completed: oldul[completed] || minValue,
        isLevel: oldul.id.indexOf('gs-0') > -1,
      })
      to.push({
        id: newul.id,
        completed: newul[completed] || minValue,
        isLevel: newul.id.indexOf('gs-0') > -1,
      })
    }
  })

  
  from = from.filter((item, i) => item.completed !== to[i]?.completed)
  to = to.filter((item, i) => item.id === from[i]?.id)
  
  return { from, to }

}

/**
 * This funtcion generate log marking comparing new marking to old marking
 * @param {Object} oldUL old ul marked
 * @param {Object} newUL new ul  marked
 * @param {Object} user user session logged
 * @param {Number} ilc  index lc marked
 * @param {String} idLc  id lc marked
 * @param {String} type type log bulk or simple
 * @param {String} completed type complete markingTeacher || markingStudent
 */
const getLogSingleMarking = (oldUL, newUL, user, ilc, idLc, type, completed, minValue) => {
  const { from, to } = generateFromToLogMarking(oldUL, newUL, ilc, completed, minValue)

  if (from.length > 0) {
    return {
      username: `${user.firstName} ${user.lastName}`,
      userid: user._id,
      usercode: user.code,   
      type,
      skills: idLc,
      from, to, 
    }
  } else {
    return null
  }
}

/**
 * This funtcion generate log marking comparing new marking to old marking
 * @param {Object} oldUL old ul marked
 * @param {Object} newUL new ul  marked
 * @param {Object} user user session logged
 * @param {Number} ilc  index lc marked
 * @param {String} idLc  id lc marked
 * @param {String} type type log bulk or simple
 * @param {String} completed type complete markingTeacher || markingStudent
 */
const getLogMarking = (oldUL, newUL, user, ilc, idLc, type, completed, minValue) => {
  const log = getLogSingleMarking(oldUL, newUL, user, ilc, idLc, type, completed, minValue)

  if (log) {
    return [
      log,
      ...oldUL.logMarking,
    ]
  } else {
    return null
  }
}
 /**
 * This function find index by OrganisingElement, skills, levels and gs
 * formatt AbbreviationDiscipline-AbbreviationLevels
 @param {Array} listLC - List al LC by Area and Discipline class
 @param {Object} currentLC - _id Current learning continuum 
 @param {Array} listLC - List level
 @param {Object} currentGS - Current granular step
 */
const getIndexLC = (listLC, currentLC, levelsDB, currentGS) => {
  const dataLC = listLC.find((lc) => lc._id === currentLC._id) || {}

  const listOrganisingElement = removeDuplicates(listLC, 'organisingElements')
  const indexOrganisingElement = findIndex(listOrganisingElement, dataLC.organisingElements || '', 'organisingElements')
  
  const listSkills = listLC.filter((lc) => lc.organisingElements === dataLC.organisingElements)
  const indexSkills = findIndex(listSkills, dataLC.skills || '', 'skills')

  const indexGS = findIndex(currentLC.granularSteps, currentGS.id || '', 'id')

  const level = levelsDB.find((l) => l._id === currentGS.levelId)
  const indexLevel = level ? level.shortName : currentGS.levelId

  return {
    indexOrganisingElement, indexSkills, indexGS, indexLevel
  }
}

 /**
 * This function generate code marking in lcs 
 @param {String} discipline - Discipline class
 @param {String} indexLevel - level  learning continuum
 @param {Number} indexOrganisingElement - position lc by OrganisingElement
 @param {Number} indexSkills - position lc by Skills
 @param {String} iGS - index granular step
 */
const generateCodeMarkingLcs = (discipline, indexLevel, indexOrganisingElement, indexSkills, igs) => `(${discipline}-${indexOrganisingElement+1}.${indexSkills+1}.${indexLevel}.${igs})`

/*
 * Marking
 */

/**
 * This function find log marking for show photo
 @param {Object} ul - Unit of learning
 */

const genetareInfoLogMarkingPhoto = (ul = {}, completed, log, itemsMarking = []) => {
  if (!ul?.lcs) return []
  const minValue = itemsMarking.find((item) => item.minValue)

  if (!minValue) return []
  return ul.lcs.map((lc) => {
    let level = ''
    let findPrimary = false
    let granularSteps = lc.granularSteps ? reverseData(lc.granularSteps) : []
    let currentGS = []

    granularSteps.forEach((gs) => {
      if (gs[completed] !== minValue.value) {
        if (gs[completed] !== minValue._id) {
          const findMarking = itemsMarking.find((item) => item.value ===  gs[completed] || item._id ===  gs[completed])
          if (gs.id.indexOf('-gs-0') > -1) {
            if (!findPrimary) {
              currentGS.push({
                id: gs.id,
                completed: gs[completed],
                markingName: findMarking?.name,
                primaryColor: findMarking?.primaryColor,
                secondaryColor: findMarking?.secondaryColor,
              })
              findPrimary = true
              level = gs.levelId              
            }
          } else {
            if (gs.levelId === level) {
              currentGS.push({
                id: gs.id,
                completed: gs[completed],
                markingName: findMarking?.name,
                primaryColor: findMarking?.primaryColor,
                secondaryColor: findMarking?.secondaryColor,
              })              
            }
          }
        }     
      }                 
    })

    currentGS = currentGS.map((gs) => {
      const filter = ul[log]?.filter((log) => log.skills === lc._id)
      const find = filter?.find((log) => log.to.some((item) => item.id === gs.id))
      if (find) {

        let usercode = find.usercode
        if (find.type === 'close' && find.notes) {
          
          let userscode = find.notes?.map((item) => item.usercode) || []
          if (userscode.length > 0) {
            userscode = new Set(userscode)
            userscode = [...userscode]
            userscode = userscode.filter((item) => !!item)
            usercode =  userscode.join(', ')
          }
        }

        return { 
          ...gs, 
          date: find.date || '',
          usercode: find.usercode,
          markingType: find.type,
          markingBy: usercode, 
        }
      } else {
        return { 
          ...gs,
          date: '',
          markingBy: '',
        }
      }
    })
    return { currentGS, _id: lc._id }
  })
} 




/**
 * This function find log marking for show tooltip
 @param {Object} ul - Unit of learning
 */

const genetareInfoLogMarkingTooltip = (ul = {}, completed, itemsMarking = [])  => {
  if (!ul?.lcs) return []
  const minValue = itemsMarking.find((item) => item.minValue)

  if (!minValue) return []

  return ul?.lcs?.map((lc) => {
    let granularSteps = lc.granularSteps ? reverseData(lc.granularSteps) : []
    let currentGS = []

    granularSteps.forEach((gs) => {
      if (gs[completed] !== minValue.value) {
        if (gs[completed] !== minValue._id ) {
          const find = itemsMarking.find((item) => item.value ===  gs[completed] || item._id ===  gs[completed])

          currentGS.push({
            id: gs.id,
            completed: gs[completed],
            markingName: find?.name,
            primaryColor: find?.primaryColor,
            secondaryColor: find?.secondaryColor,
          })
        }   
      }                 
    })

    currentGS = currentGS.map((x) => {
      const find = ul?.logMarking?.find((log) => log.skills === lc._id && log.to.some((to) => to.id === x.id))
      if (find) {
        let usercode = find.usercode
        if (find.type === 'close' && find.notes) {
          let userscode = find.notes?.map((item) => item.usercode) || []
          if (userscode.length > 0) {
            userscode = new Set(userscode)
            userscode = [...userscode]
            userscode = userscode.filter((item) => !!item)
            usercode =  userscode.join(', ')
          }
        }
        return { 
          ...x, 
          usercode: find.usercode,
          markingType: find.type,
          date: find.date, 
          markingBy: usercode, 
        }
      } else {
        return { 
          ...x,
          date: '',
          markingBy: '',
        }
      }
    })
    return { currentGS, _id: lc._id }
  })
} 

/**
 * This function generate width for Marking
 @param {number} length - Length lcs 
 */
const generateWidthMarking = (length) => {
  let width = {}
  if (length > 7 ) {
    width = { width: `${length * 12}vw` }
  }
  return width
}


/*
 * Bulk Marking
 */

 /**
 * This function find log marking of student and show photo
 @param {Array} studentsList - Student list
 @param {String} classId - Class id
 @param {String} ulId - Unit of learning id
 @param {Object} ul - Unit of learning
 */
const findStudentLevel = (studentsList = [], classId, ulId, itemsMarking) => {
  const minValue = itemsMarking.find((item) => item.minValue)
  const ulbyStudents = []

  studentsList.forEach((student) => {
    const ul = student?.unitOfLearnings
    if (ul) {
      if (ul.idClass === classId && ul.idUL === ulId && ul.lcs) {
    
        const ulByStudent = ul.lcs.map((lc) => {
          let findPrimary = false
          let level = ''
          let granularSteps = lc.granularSteps ? reverseData(lc.granularSteps) : []
          let currentGS = []

          granularSteps.forEach((gs) => {
            if (gs.completedTeacher !== minValue.value) {
              if (gs.completedTeacher !== minValue._id) {
                const findMarking = itemsMarking.find((item) => item.value ===  gs.completedTeacher || item._id ===  gs.completedTeacher)

                if (gs.isLevel) {
                  if (!findPrimary) {
                    currentGS.push({
                      id: gs.id,
                      completed: gs.completedTeacher,
                      markingName: findMarking?.name,
                      primaryColor: findMarking?.primaryColor,
                      secondaryColor: findMarking?.secondaryColor,
                      
                    })
                    findPrimary = true
                    level = gs.levelId              
                  }
                } else {
                  if (gs.levelId === level) {
                    currentGS.push({
                      id: gs.id,
                      completed: gs.completedTeacher,
                      markingName: findMarking?.name,
                      primaryColor: findMarking?.primaryColor,
                      secondaryColor: findMarking?.secondaryColor,
                    })              
                  }
                }
              } 
            }                 
          })
          currentGS = currentGS.map((x) => {
            const find = ul.logMarkingTeacher ? ul.logMarkingTeacher.find((log) => log.skills === lc._id && log.to.some((to) => to.id === x.id)) : null
            if (find) {
              let usercode = find.usercode
              if (find.type === 'close' && find.notes) {
                let userscode = find.notes?.map((item) => item.usercode) || []
                if (userscode.length > 0) {
                  userscode = new Set(userscode)
                  userscode = [...userscode]
                  userscode = userscode.filter((item) => !!item)
                  usercode =  userscode.join(', ')
                }
              }
              return { 
                ...x, 
                usercode: find.usercode,
                markingType: find.type,
                date: find.date, 
                markingBy: usercode, 
              }
            } else {
              return { ...x }
            }                
          })

          return { skills: lc.skills, _id: lc._id, currentGS }
        })

        ulbyStudents.push({
          _id: student._id,
          code: student.code,
          photo: student.photo,
          lcs: ulByStudent,
        })
      }
    }
  })

  return removeDuplicates(ulbyStudents)
}

const getLogBulkMarking = (data, user, idUL, students) => {
  const logBulkMarking = data.logBulkMarking ? data.logBulkMarking : []
  let id =  `bulk-${idUL}-1`
  if (data.logBulkMarking && data.logBulkMarking.length > 0) {
    let number = data.logBulkMarking[0].id
    if (number) {
      number = number.split('-')
      number = parseInt(number[number.length - 1]) + 1
      id =  `bulk-${idUL}-${number}`
    }
  }

  return [
    {
      id,
      students: students.map((x) => ({ _id: x._id, code: x.code, firstName: x.firstName, lastName: x.lastName, name: `${x.firstName} ${x.lastName}`, photo: x.photo })),
      logMarking: data.logMarking, 
      status: 1,
      logs: [
        { 
          date: new Date(),
          username: `${user.firstName} ${user.lastName}`,
          userid: user._id,
          usercode: user.code,   
          action: 'Created',
        }
      ]
    },
    ...logBulkMarking
  ]
}

const sortLCS = (dataLCS, levels) => {
  let lcs = dataLCS.map((lc) => {
    let granularSteps = []

    levels.forEach((lvl) => {
      let items = lc.granularSteps.filter((gs) => gs.levelId === lvl)
      items = items.map((gs) => ({ ...gs, order: parseInt(gs.id.split('gs-')[1]) }))
      items = sortData(items, 'order', 'desc', 'number')
      items = reverseData(items)
      items = items.map((gs) => {
        delete gs.order
        return gs
      })
      
      granularSteps = [...items, ...granularSteps]
    })

    return { ...lc, granularSteps}
  })
  lcs = sortDataByTwoColumns(lcs, 'organisingElements', 'skills')        
  return lcs
}

const markingMovement = {
  EXCLUDE: 'exclude',
}

export {
	genetareInfoLogMarkingTooltip, genetareInfoLogMarkingPhoto, generateWidthMarking,
  getLogMarking, getLogSingleMarking,
  generateFromToLogMarking, generateCodeMarkingLcs,
  findStudentLevel, getLogBulkMarking, getIndexLC, sortLCS,
  markingMovement
}